import React, { useEffect, useState } from "react";
import { AuthStatus } from "services/cognitoService/AuthStatus";
import { useMediaQuery } from "react-responsive";
import { AuthContext } from "app/contexts/auth/authContext";
import { LayoutContext } from "../context/layoutContext";
import { Header } from "../../components/Header/Header";
import Footer from "../../components/Footer";
import { Navbar } from "../../components/Navbar/Navbar";
import "./style.scss";
import {NavigateFunction, Outlet} from "react-router-dom";
import {useNavigate} from "react-router";
import {ROUTE_PATHS} from "../../consts/RoutePaths";

const DashboardLayout = () => {
   const { authStatus, signOutForTimeout } = React.useContext(AuthContext);
   const [isNavBarExpanded, setIsNavBarExpanded] = useState<boolean>(false);
   const isMobile: boolean = useMediaQuery({ maxWidth: 767 });
   const isSignedIn: boolean = authStatus === AuthStatus.SignedIn;
   const navigate: NavigateFunction = useNavigate();

   useEffect(() => {
      if (isMobile && isNavBarExpanded) {
         setIsNavBarExpanded(false);
      }
   }, [isMobile]);

   const onDocumentClick = (event) => {
      const rollingExpiration = sessionStorage.getItem("rollingExpiration");

      if (rollingExpiration) {
         const expiration = parseInt(rollingExpiration);
         const now: number = Math.floor(Date.now() / 1000);

         if (now > expiration) {
            signOutForTimeout();
            navigate(ROUTE_PATHS.SIGNED_OUT);
         }
      }

      if (isSignedIn && isNavBarExpanded) {
         setIsNavBarExpanded(!isNavBarExpanded);
      }
   }

   return (
       <LayoutContext.Provider
           value={{ isMobile, isSignedIn, isNavBarExpanded, setIsNavBarExpanded }}
       >
          <div id={"layout"}>
             <Header />
             <div id={"layout-content"}>
                {isSignedIn && <Navbar />}
                <div id={"layout-main"}>
                   <div id={"layout-outlet"} onClick={onDocumentClick}>
                      <Outlet />
                   </div>
                   <Footer />
                </div>
             </div>
          </div>
       </LayoutContext.Provider>
   );
};

export default DashboardLayout;
